import React from 'react'
import './index.scss'

const Loading = () => (
  <div className="loading-wrap">
    <div className="lds-ring">
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
)

export default Loading
